import {
    EuiButton,
    EuiFlexGroup,
    EuiFlexItem,
    EuiLoadingSpinner,
    EuiPopover,
    EuiButtonIcon,
    EuiToolTip,
} from "@elastic/eui";
import React from "react";
import { FormattedMessage } from "react-intl";

function EditButton({ onClick }) {
    return (
        <EuiToolTip content={<FormattedMessage id="action.edit" />}>
            <EuiButtonIcon
                display="fill"
                iconType="pencil"
                iconSide="left"
                size="s"
                onClick={onClick}
                style={{
                    background: "#006BB440 0% 0% no-repeat padding-box",
                    marginLeft: "10px",
                }}
            />
        </EuiToolTip>
    );
}

function ConfirmButton({ onClick }) {
    return (
        <EuiToolTip content={<FormattedMessage id="action.confirm" />}>
            <EuiButtonIcon
                display="fill"
                iconType="check"
                iconSide="left"
                size="s"
                onClick={onClick}
                style={{
                    background: "#54B39940 0% 0% no-repeat padding-box",
                    marginLeft: "10px",
                    color: "#54B399",
                }}
            />
        </EuiToolTip>
    );
}

function TripFieldForm({
    isPopoverOpen,
    openPopover,
    openConfirmingPopover,
    closePopover,
    input,
    onSubmit,
    fullWidth,
    isLoading,
    isConfirmable,
}) {
    return (
        <EuiPopover
            button={
                !isLoading ? (
                    <>
                        <EditButton onClick={openPopover} />
                        {isConfirmable && <ConfirmButton onClick={openConfirmingPopover} />}
                    </>
                ) : (
                    <EuiLoadingSpinner
                        style={{ marginLeft: 10 }}
                        size="m"
                    />
                )
            }
            isOpen={isPopoverOpen}
            closePopover={closePopover}
        >
            <div>
                <EuiFlexGroup
                    alignItems="center"
                    gutterSize="xs"
                    wrap={!!fullWidth}
                    style={{ maxWidth: "500px" }}
                >
                    <EuiFlexItem
                        grow
                        style={{ width: fullWidth ? "100%" : "auto" }}
                    >
                        {input}
                    </EuiFlexItem>
                    <EuiFlexItem
                        grow={false}
                        style={{ width: fullWidth ? "100%" : "auto" }}
                    >
                        <EuiButton
                            onClick={() => {
                                onSubmit();
                                closePopover();
                            }}
                            fill
                        >
                            <FormattedMessage id="action.save" />
                        </EuiButton>
                    </EuiFlexItem>
                </EuiFlexGroup>
            </div>
        </EuiPopover>
    );
}

export default TripFieldForm;
